import React, { useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import APIRequest from "system/APIRequest";

import ISORelativeDateTime, { relativeTimeString } from "components/formatting/ISORelativeDateTime";
import { DashboardDocument } from "components/resources/dashboards/DashboardDocument";
import { ResourceChange } from "../ChangeLog";
import { currentUser } from "system/InfegyUser";

interface DashboardDetailsProps {
  dashboardId: string;
  lastChange: ResourceChange;
}

export default function DashboardDetails(props: DashboardDetailsProps): React.JSX.Element {
  const { i18n } = useTranslation();
  const me = currentUser();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dashboard, setDashboard] = useState<DashboardDocument | null>(null);

  async function load(): Promise<void> {
    setIsLoading(true);

    const response: any = await APIRequest(`obj/dashboard/${props.dashboardId}`, undefined, undefined, true);
    const dashboard = response.output as DashboardDocument;
    
    setDashboard(dashboard);
    setIsLoading(false);
  }

  useEffect(() => {
    load();
  }, [props.dashboardId]);

  let lastUpdateUser = i18n.t("you");
  if (!props.lastChange.user_email) {
    lastUpdateUser = i18n.t("someone-else");
  } else if (props.lastChange.user_email !== me?.email) {
    lastUpdateUser = props.lastChange.user_email;
  }

  return (
    <Box>
      {dashboard &&
        <Stack>
          <Stack direction="row" sx={{gap: 0.5, justifyContent: "space-between"}}>
            <Typography variant="h4" sx={{p: 0, m:0}}>
              {dashboard.name}
            </Typography>
            <Typography sx={{fontStyle: "italic", opacity: 0.5}}>{i18n.t("change-log.resource-type.dashboard")}</Typography>
          </Stack>
          <Stack direction="row" sx={{gap: 0.5}}>
            <Typography>
              <Trans
                i18nKey="change-log.last-updated"
                values={{
                  person: lastUpdateUser,
                  relativeTime: relativeTimeString(new Date(dashboard.updated_at))
                }}
              />
            </Typography>
          </Stack>
        </Stack>
      }
    </Box>
  )
}